// @ts-ignore
import {CognitoUser} from 'amazon-cognito-identity-js';
import {UserDto} from '@api/utisha-backend';
import UserTypeEnum = UserDto.UserTypeEnum;

type MyUserAttributes = {
  sub: string;
  email: string;
  email_verified: string;
  name: string;
  birthdate: string;
  given_name: string,
  middle_name: string,
  family_name: string,
  picture: string,
  updated_at: string;
  'custom:userType': string;
};


// @ts-ignore
export type MyCognitoUser = CognitoUser & { attributes: MyUserAttributes; };

const isStudent = (user: UserDto) => {
  return user.userType === UserTypeEnum.Student;
};

const isTeacher = (user?: UserDto) => {
  return user?.userType === UserTypeEnum.Teacher;
};

export {isStudent, isTeacher};

